export default "__VITE_ASSET__Y0xgwjkn__"